import { render, staticRenderFns } from "./ClinicOrderList.vue?vue&type=template&id=750bdddf&scoped=true&"
import script from "./ClinicOrderList.vue?vue&type=script&lang=js&"
export * from "./ClinicOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ClinicOrderList.vue?vue&type=style&index=0&id=750bdddf&prod&lang=scss&scoped=true&"
import style1 from "./ClinicOrderList.vue?vue&type=style&index=1&id=750bdddf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750bdddf",
  null
  
)

export default component.exports